import type {BoxProps} from '@tempo/core';
import {IFrame} from './Iframe';

export type DeezerWidgetProps = BoxProps & {
	type: 'playlist' | 'track' | 'album' | 'artist' | 'podcast' | 'episode';
	id: string;
	title?: string;
};
export const DeezerWidget: React.FC<DeezerWidgetProps> = ({
	type,
	id,
	title = 'deezer-widget',
	...boxProps
}) => {
	return (
		<IFrame
			title={title}
			src={`https://widget.deezer.com/widget/dark/${type}/${id}`}
			width={{base: '300px', md: '900px'}}
			height="310px"
			frameBorder="0"
			borderRadius="xl"
			allow="encrypted-media; clipboard-write"
			{...boxProps}
		/>
	);
};
